import { api } from '@creditsights/api-ui-web';
import { orderBy } from 'lodash';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const fetchCountries = async () => {
  const { data } = await api.get('profile/v1/profiles/lookups/countries');
  return orderBy(data, ['label'], ['asc']);
};

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const fetchStates = async (countryCode) => {
  const { data } = await api.get('profile/v1/profiles/lookups/states', { params: { countryCode } });
  return data;
};
